export default __webpack_public_path__ + "static/media/Asset 9.562ed86e.png";